<template>
  <div class="invoice-code container">
    <a-page-header class="header" title="电子发票" />
    <a-spin class="loading" v-if="loading" size="large"></a-spin>
    <div v-else>
      <div style="display: flex; justify-content: center;">
        <div class="code-pic">
          <img class="img" alt="img" :src="imageSrc" />
        </div>
      </div>
      <div v-if="tips" class="tips">
        <span class="tips-info" v-html="tips"></span>
      </div>
    </div>
  </div>
</template>
<script>
import './index'
import { get } from 'lodash'

export default {
  data () {
    return {
      loading: true,
      tips: '',
      imageSrc: null
    }
  },
  created () {
    this.getCmsData()
  },
  methods: {
    // 通过cms获取图片地址及温馨提示
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { imgUrl, content } = get(res, 'invoice-entry') ?? {}
          if (!imgUrl) {
            this.$message.error('信息不完整,返回上一页')
            setTimeout(() => {
              this.$router.go(-1)
            }, 2000)
          } else {
            this.imageSrc = imgUrl
            this.tips = content
            this.loading = false
          }
        })
      } catch (err) {}
    }
  }
}
</script>
<style>
  .header {
    border-bottom: 1px solid #ddd;
  }

  .loading {
    width: 100%;
    text-align: center;
    margin-top: 50px;
  }

  .code-pic {
    margin-top: 30px;
    height: 400px;
    width: 400px;
    padding: 10px;
    background-color: #fff;
  }

  .img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .tips {
    margin-top: 20px;
  }

  .tips-info {
    font-size: 12px;
    color: #7f7f7f;
  }
</style>
